module.exports = __webpack_public_path__ + "static/media/img_Characterdesign-Junior-03Third_J04.835573e6.png";